/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audio_Recorder_Device_ChangedInputs */

const en_audio_recorder_device_changed = /** @type {(inputs: Audio_Recorder_Device_ChangedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Audio device changed successfully`)
};

const fr_audio_recorder_device_changed = /** @type {(inputs: Audio_Recorder_Device_ChangedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Périphérique audio changé avec succès`)
};

const de_audio_recorder_device_changed = /** @type {(inputs: Audio_Recorder_Device_ChangedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Audiogerät erfolgreich gewechselt`)
};

const it_audio_recorder_device_changed = /** @type {(inputs: Audio_Recorder_Device_ChangedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dispositivo audio modificato correttamente`)
};

const ru_audio_recorder_device_changed = /** @type {(inputs: Audio_Recorder_Device_ChangedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Аудиоустройство успешно изменено.`)
};

const es_audio_recorder_device_changed = /** @type {(inputs: Audio_Recorder_Device_ChangedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`El dispositivo de audio se cambió correctamente`)
};

const zh_cn2_audio_recorder_device_changed = /** @type {(inputs: Audio_Recorder_Device_ChangedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`音频设备已成功更换`)
};

const ja_audio_recorder_device_changed = /** @type {(inputs: Audio_Recorder_Device_ChangedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`オーディオデバイスが正常に変更されました`)
};

const hi_audio_recorder_device_changed = /** @type {(inputs: Audio_Recorder_Device_ChangedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ऑडियो डिवाइस सफलतापूर्वक बदल दिया गया`)
};

const pt_pt2_audio_recorder_device_changed = /** @type {(inputs: Audio_Recorder_Device_ChangedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dispositivo de áudio alterado com sucesso`)
};

/**
* | output |
* | --- |
* | "Audio device changed successfully" |
*
* @param {Audio_Recorder_Device_ChangedInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const audio_recorder_device_changed = /** @type {((inputs?: Audio_Recorder_Device_ChangedInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audio_Recorder_Device_ChangedInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_audio_recorder_device_changed(inputs)
	if (locale === "de") return de_audio_recorder_device_changed(inputs)
	if (locale === "it") return it_audio_recorder_device_changed(inputs)
	if (locale === "ru") return ru_audio_recorder_device_changed(inputs)
	if (locale === "es") return es_audio_recorder_device_changed(inputs)
	if (locale === "zh-CN") return zh_cn2_audio_recorder_device_changed(inputs)
	if (locale === "ja") return ja_audio_recorder_device_changed(inputs)
	if (locale === "hi") return hi_audio_recorder_device_changed(inputs)
	if (locale === "pt-PT") return pt_pt2_audio_recorder_device_changed(inputs)
	return en_audio_recorder_device_changed(inputs)
});